import React from 'react';
import "./Box.css"


const Box = (props) => {
    const {icon,name,head,details} = props.data;
    return (
        <div className='box'>
            {icon}
            <h6>{name}</h6>
            <h3 style={{fontSize:'20px', fontWeight:'bold', color:"white", marginTop:'30px'}}>{head}</h3>
            <h6>{details}</h6>
        </div>
    );
};

export default Box;